import { useEffect } from "react";
import { useSelector } from "react-redux";
import { initialiseOrReinitUser } from "../../mixpanel/mixpanel";

const UserInitializerForEvents = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  useEffect(() => {
    // Re-runs whenever the logged-in user changes, so a logout + login as
    // someone else in the same tab is identified as that new user.
    if (!currentUser?.id?.uuid) return;

    const { email, profile } = currentUser?.attributes || {};
    const { publicData, firstName, lastName } = profile || {};
    const { userType, signupFrom } = publicData || {};

    const initUser = async () => {
      try {
        await initialiseOrReinitUser({
          firstName,
          lastName,
          email,
          userId: currentUser.id.uuid,
          userType,
          signupFrom,
        });
      } catch (err) {
        console.error("Error initializing user for events:", err);
      }
    };

    initUser();
  }, [currentUser?.id?.uuid]);

  return null; // This component doesn’t render anything
};

export default UserInitializerForEvents;
